import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BusTable = () => {
    const [formData, setFormData] = useState({
        busNumber: '',
        class: '',
        section: '',
        student: '',
        route:'',
    });
    const [buses, setBuses] = useState([]);
    const [classes, setClasses] = useState([]);
    const [sections, setSections] = useState([]);
    const [students, setStudents] = useState([]);
    const [assignments, setAssignments] = useState([]);
    const [selectedClass, setSelectedClass] = useState('');
    const [selectedSection, setSelectedSection] = useState('');
    const [editId, setEditId] = useState(null);
    const [error, setError] = useState(null);
     const currentSessionId = localStorage.getItem("currentSessionId");

    // Fetch buses, classes, and assignments
    useEffect(() => {
        // Fetch buses
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/busSchedules/getAllBusSchedules`)
            .then(response => setBuses(response.data))
            .catch(error => console.error('Error fetching buses:', error));

        // Fetch assignments
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/assignments`)
            .then(response => setAssignments(response.data))
            .catch(error => console.error('Error fetching assignments:', error));
    }, []);

    // Fetch classes
    useEffect(() => {
        const fetchClasses = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/classes/getClasses`);
                setClasses(response.data);
            } catch (err) {
                setError(`Error: ${err.message}`);
            }
        };

        fetchClasses();
    }, []);

    // Fetch sections based on selected class
    useEffect(() => {
        if (selectedClass) {
            const fetchSections = async () => {
                try {
                    const response = await axios.get(` ${process.env.REACT_APP_API_BASE_URL}/api/sections/${selectedClass}/getSectionsByClassName`);
                    setSections(response.data);
                    setSelectedSection(''); // Reset section when class changes
                } catch (err) {
                    setError(`Error: ${err.message}`);
                }
            };

            fetchSections();
        } else {
            setSections([]);
            setSelectedSection('');
        }
    }, [selectedClass]);

    // Fetch students based on selected class and section
    useEffect(() => {
        if (selectedClass && selectedSection) {
            const fetchStudents = async () => {
                try {
                    const response = await  axios.get(' /api/students/getStudents', {
          params: { sessionId: currentSessionId },
        });
                    // Filter students based on selected class and section
                    const filteredStudents = response.data.filter(student =>
                        student.class === selectedClass && student.section === selectedSection
                    );
                    setStudents(filteredStudents);
                } catch (error) {
                    console.error('Error fetching student data:', error);
                }
            };

            fetchStudents();
        } else {
            setStudents([]);
        }
    }, [selectedClass, selectedSection]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({ ...prevState, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (editId) {
            axios.put(`/api/assignments/${editId}`, formData)
                .then(() => {
                    setFormData({ busNumber: '', class: '', section: '', student: '',route:'', });
                    setEditId(null);
                    fetchAssignments();
                })
                .catch(error => console.error('Error updating assignment:', error));
        } else {
            axios.post('/api/assignments', formData)
                .then(() => {
                    setFormData({ busNumber: '', class: '', section: '', student: '',route:'', });
                    fetchAssignments();
                })
                .catch(error => console.error('Error creating assignment:', error));
        }
    };

    const fetchAssignments = () => {
        axios.get('/api/assignments')
            .then(response => setAssignments(response.data))
            .catch(error => console.error('Error fetching assignments:', error));
    };

    const handleClassChange = (e) => {
        setSelectedClass(e.target.value);
    };

    const handleSectionChange = (e) => {
        setSelectedSection(e.target.value);
    };

    const handleEdit = (assignment) => {
        setFormData({
            busNumber: assignment.busNumber,
            class: assignment.class,
            section: assignment.section,
            student: assignment.student,
            route:assignment.route,
        });
        setEditId(assignment._id);
    };

    const handleDelete = (id) => {
        axios.delete(`/api/assignments/${id}`)
            .then(() => fetchAssignments())
            .catch(error => console.error('Error deleting assignment:', error));
    };

    return (
        <div className="container mx-auto p-4">
            <h1 className="text-2xl font-bold mb-4">{editId ? 'Edit Assignment' : 'Add New Assignment'}</h1>
            <form onSubmit={handleSubmit} className="mb-6">
                <div className="mb-4">
                    <label className="block text-gray-700">Class</label>
                    <select
                        value={selectedClass}
                        onChange={handleClassChange}
                        className="border border-gray-300 p-2 w-full"
                    >
                        <option value="">Select Class</option>
                        {classes.map((cls) => (
                            <option key={cls._id} value={cls.className}>
                                {cls.className}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700">Section</label>
                    <select
                        value={selectedSection}
                        onChange={handleSectionChange}
                        disabled={!selectedClass}
                        required
                        className="border border-gray-300 p-2 w-full"
                    >
                        <option value="">Select Section</option>
                        {sections.map((section) => (
                            <option key={section._id} value={section.sectionName}>
                                {section.sectionName}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700">Student</label>
                    <select
                        name="student"
                        value={formData.student}
                        onChange={handleChange}
                        className="border border-gray-300 p-2 w-full"
                        required
                    >
                        <option value="">Select Student</option>
                        {students.map(student => (
                            <option key={student._id} value={student._id}>{student.firstName}</option>
                        ))}
                    </select>
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700">Route</label>
                    <select
                        name="busNumber"
                        value={formData.busNumber}
                        onChange={handleChange}
                        className="border border-gray-300 p-2 w-full"
                        required
                    >
                        <option value="">Select Bus</option>
                        {buses.map(bus => (
                            <option key={bus._id} value={bus.busNumber}>{bus.route}</option>
                        ))}
                    </select>
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700">Bus Number</label>
                    <input
                        type="text"
                        name="route"
                        value={formData.busNumber}
                        onChange={handleChange}
                        className="border border-gray-300 p-2 w-full"
                        disabled
                    />
                </div>
                <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Route Time</label>
          <select
            value={formData.route}
            onChange={handleChange}
            className="block w-full border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm py-2 px-3"
          >
            <option value="" disabled>Select route type</option>
            <option value="Old Student">One Way</option>
            <option value="New Student">Two Way</option>
          </select>
        </div>
                <button type="submit" className="bg-blue-500 text-white p-2 rounded">
                    {editId ? 'Update Assignment' : 'Add Student'}
                </button>
            </form>
            <h2 className="text-xl font-bold mb-4">Assignments</h2>
            <table className="min-w-full border border-gray-300">
                <thead>
                    <tr>
                        <th className="border border-gray-300 p-2">Bus Number</th>
                        <th className="border border-gray-300 p-2">Class</th>
                        <th className="border border-gray-300 p-2">Section</th>
                        <th className="border border-gray-300 p-2">Student</th>
                        <th className="border border-gray-300 p-2">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {assignments.map(assignment => (
                        <tr key={assignment._id}>
                            <td className="border border-gray-300 p-2">{assignment.busNumber}</td>
                            <td className="border border-gray-300 p-2">{assignment.class}</td>
                            <td className="border border-gray-300 p-2">{assignment.section}</td>
                            <td className="border border-gray-300 p-2">{assignment.student}</td>
                            <td className="border border-gray-300 p-2">
                                <button onClick={() => handleEdit(assignment)} className="bg-yellow-500 text-white p-1 rounded mr-2">
                                    Edit
                                </button>
                                <button onClick={() => handleDelete(assignment._id)} className="bg-red-500 text-white p-1 rounded">
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default BusTable;
